import { createContext } from 'react';
import {
	sanityAppMediaUrl,
	sanityInvestorMediaUrl,
} from '@dealstack/frontend/app/pages/HelpBlog/sanity-frontend-client.ts';
import type { ClientPerspective } from '@sanity/client';
import { ApplicationType } from '@dealstack/shared/lib/generated';

export const useHelpBlogController = (
	dataset: ApplicationType,
	perspective?: ClientPerspective
) => {
	const mediaResolver =
		dataset === ApplicationType.DEALSTACK ? sanityAppMediaUrl : sanityInvestorMediaUrl;

	return { dataset, perspective, mediaResolver };
};

export const HelpBlogContext = createContext<ReturnType<typeof useHelpBlogController>>(
	{} as ReturnType<typeof useHelpBlogController>
);
